import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Settings2 } from 'lucide-react';
import { toast } from 'sonner';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const EMPRESAS = ['edp', 'galp', 'endesa', 'iberdrola', 'gold', 'repsol', 'yes', 'nos', 'meo', 'vodafone', 'nos_securitas', 'prosegur'];

export const CcCompaniesSetting = () => {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const isAdmin = ['super_admin', 'gestor'].includes(user?.role);

  useEffect(() => {
    if (isAdmin) axios.get(`${API_URL}/settings/cc-required-companies`).then((r) => setCompanies(r.data.companies || [])).catch(() => {});
  }, [isAdmin]);
  if (!isAdmin) return null;

  const toggle = async (c) => {
    const next = companies.includes(c) ? companies.filter((x) => x !== c) : [...companies, c];
    try {
      const r = await axios.put(`${API_URL}/settings/cc-required-companies`, { companies: next });
      setCompanies(r.data.companies);
    } catch {
      toast.error('Erro ao guardar');
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="ml-auto text-indigo-400 hover:text-indigo-700" title="Empresas que exigem Cartão de Cidadão" data-testid="cc-companies-setting-btn">
          <Settings2 className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64" data-testid="cc-companies-popover">
        <p className="text-xs font-semibold text-slate-700 mb-2">Exigir Cartão de Cidadão no link</p>
        <div className="grid grid-cols-2 gap-1">
          {EMPRESAS.map((c) => (
            <label key={c} className="flex items-center gap-1.5 text-xs cursor-pointer">
              <input type="checkbox" checked={companies.includes(c)} onChange={() => toggle(c)} className="accent-[#2D3E6F]" data-testid={`cc-company-${c}`} />
              {c.replace('_', ' ').toUpperCase()}
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
